import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainContent from './component/MainContent/MainContent';
import WelcomePage from './component/MainContent/WelcomePage'; // You'll create this

import './App.css';
import './assets/colors.css';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<WelcomePage />} />
        <Route path="/menu" element={<MainContent />} />
      </Routes>
    </Router>
  );
};

export default App;
